import { Component, Input } from "@angular/core"
import { CHNode } from "../../models/node.model"

@Component({
    selector: "app-student-subjects-grid",
    templateUrl: "./student-subjects-grid.component.html",
    styleUrls: ["./student-subjects-grid.component.scss"],
})
export class StudentSubjectsGridComponent {
    @Input() subjectTreeChildren: CHNode[]
}
